
<main id="page-wrapper">
  <router-outlet></router-outlet>
</main>
<app-notification></app-notification>
